export const app_store_random_games_en = {
  randomTwoGame: "Random Two Games",
  release_date: "Release Date",
  last_release_date: "Last Release Date"
};
